type RightArrowProps = {
  onClick?: () => any;
  disabled?: boolean;
};

export const RightArrow = ({onClick, disabled}: RightArrowProps) => {
  const color = disabled ? '#7D7D7D' : '#000000';
  return (
    <svg
      onClick={onClick}
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M7 1L2 6L7 11" stroke={color} strokeWidth="2" />
    </svg>
  );
};
